// extracted by mini-css-extract-plugin
export default {"error":"ApplicationLoader--error__cXCUh1"};